export default "__VITE_ASSET__F4L7j8ON__"